import { render, staticRenderFns } from "./ProfileUpdateError.vue?vue&type=template&id=50206876&"
import script from "./ProfileUpdateError.vue?vue&type=script&lang=js&"
export * from "./ProfileUpdateError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports